<template>
  <layout-main-inner title="OCR记录">
    <layout-card-wrap>
      <el-form
        label-width="85px"
        @submit.native.prevent>
        <el-row
          :gutter="8"
          type="flex">
          <el-col :span="6">
            <el-form-item label="委托单号：">
              <el-input
                v-model="config.appraisalNo"
                clearable=""
                placeholder="请输入委托单号" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="识别结果：">
              <el-input
                v-model="config.uniqueProductCode"
                clearable=""
                placeholder="请输入识别结果" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="识别时间:">
              <el-date-picker
                v-model="config.time"
                placement="bottom-start"
                style="width: 100%;"
                type="datetimerange"
                range-separator="/"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="开始"
                end-placeholder="结束">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="0">
              <el-button
                type="primary"
                @click="handleCurrentChange(1)">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        border
        :data="list">
        <el-table-column
          label="委托单号"
          fixed="left"
          width="160"
          prop="appraisalNo"></el-table-column>
        <el-table-column
          label="识别结果"
          min-width="120"
          prop="uniqueProductCode"></el-table-column>
        <el-table-column
          label="识别时间"
          width="150">
          <template slot-scope="{ row }">{{ row.createdTime | dateformat() }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import Ai from '@/service//ai.js'
import { getTimeRange } from '@/utils/formatTime'
export default {
  name: 'UpcOcrsPage',
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, appraisalNo: '', time: null, uniqueProductCode: '', ocrResult: 0 }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      const [beginCreatedTime, endCreatedTime, time] = getTimeRange(this.config.time)
      Ai.getocrrecords({ ...this.config, beginCreatedTime, endCreatedTime, time })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if (result === 0) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
